export default __webpack_public_path__ + "2e0ea14da29f9bba9e128b4ae4249759.png";